var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMint = function SvgMint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mint_svg__a)",
    d: "M145 193s-4.53.81-6.5 10.16C136.53 212.52 133 225 132 225s-9 0-9-2 9.02-17.76 8.88-23.1c-.14-5.35-1.88-4.9-1.88-4.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mint_svg__b)",
    d: "M137 198s-4.08 1-10.07 1-13.16-.91-19.68-5.03c-13.09-8.27-13.28-13.56-11.92-13.66s3.97-1.25 2.23-3.27-11.15-17.79-11.63-20.97-.39-3.85 1.55-4.14-2.71-4.71-3.01-7.12-.19-3.08.97-3.85-1.07-9.33-2.42-12.02-1.6-3.61.82-6.01c1.96-1.95-1.8-3.74-.92-6.78.44-1.51 1.96-3.9 1.6-5.48s.95-10.82 1.45-11.97 2.47-2.31 3.56-1.8c1.09.5-.15-4.54.8-5.77s2.18-3.53 4.51-4.76.29-6.35 3.13-8.66 3.56-1.95 4.29-5.27 7.05-11.83 14.18-14.64c7.12-2.81 4.58-4.83 11.85-6.35 7.27-1.51 12.92-2.72 13.72-4.46.43-.93 1-2 2-2s1 1 1 1c0 1 1 138 1 138l-9 14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mint_svg__c)",
    d: "M136 198s11.14-4.21 14.8-3.06c3.65 1.15 12.3-2.68 11.72-6.51s2.31-2.49 3.46-7.85c.54-2.51 13.43-6.1 12.82-14.31-.48-6.49 5.78-16.97 6.8-18.8 1.92-3.45-.02-8.78.27-10.07s2.11-1.8 2.02-4.8c-.12-3.92-1.06-1.17-1.06-4.26 0-1.72.99-4.09-.23-6.96s1.66-6.03 1.3-7.47-.22-3.3.03-5.46.04-4.38-1.91-6.32-5.76-1.8-2.16-8.69-6.99-21.26-8.07-22.19-1.66.57-2.45-.43-1.73-4.45-3.89-5.89-.54-2.69-3.6-4.31-15.28-8.26-17.22-9.91-3.18-3.83-3.61-4.7c0 0-.71-.26-.86 1.61-.14 1.87 1.37 120.94-8.14 150.38z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mint_svg__a",
    x1: 136.14,
    x2: 130.36,
    y1: 196.94,
    y2: 226.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mint_svg__b",
    x1: 97.05,
    x2: 147.21,
    y1: 190.67,
    y2: 60.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mint_svg__c",
    x1: 162,
    x2: 162,
    y1: 197.43,
    y2: 55.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgMint;